import {inject, Injectable} from '@angular/core';
import {OrgsStateModel} from './state.model';
import {Action, Selector, State, StateContext} from '@ngxs/store';
import {GetOrgsSuccessAction, SetOrgAction} from './actions';
import {WINDOW_TOKEN} from '../../tokens/window.token';

@State<OrgsStateModel>({
  name: 'orgs',
  defaults: {
    orgs: [],
  }
})
@Injectable()
export class OrgsState {
  windowRef = inject(WINDOW_TOKEN);
  @Selector()
  static getOrgs(state: OrgsStateModel) {
    return state.orgs;
  }

  @Selector()
  static selectedOrg(state: OrgsStateModel) {
    return state.selectedOrg ?? state.orgs[0]?.id;
  }

  @Action(GetOrgsSuccessAction)
  persistOrgs({ patchState }: StateContext<OrgsStateModel>, { payload }: GetOrgsSuccessAction) {
    patchState({ orgs: payload });
  }

  @Action(SetOrgAction)
  setActiveOrg({ getState, patchState }: StateContext<OrgsStateModel>, { id }: SetOrgAction) {
    const orgs = getState().orgs;
    const defaultOrg = orgs[0];
    const hasOrg = orgs.find(org => org.id === id);

    if (id === getState().selectedOrg) {
      return;
    }

    if (!id && defaultOrg) {
      patchState({ selectedOrg: defaultOrg.id });
    } else if (hasOrg) {
      patchState({ selectedOrg: id })
    } else {
      patchState({ selectedOrg: undefined });
    }

    this.windowRef.location.reload();
  }
}
